import { Logo } from "@/assets";
import { AppBar, Box, Button, Toolbar, useScrollTrigger } from "@mui/material";
import { cloneElement } from "react";
import { BrowserView, isBrowser } from "react-device-detect";
import { Link } from "react-router-dom";

interface Props {
  window?: () => Window;
  children: React.ReactElement;
}

function ElevationScroll(props: Props) {
  const { children, window } = props;
  // Note that you normally won't need to set the window ref as useScrollTrigger
  // will default to window.
  // This is only being set here because the demo is in an iframe.
  const trigger = useScrollTrigger({
    disableHysteresis: true,
    threshold: 0,
    target: window ? window() : undefined,
  });

  return cloneElement(children, {
    elevation: trigger ? 4 : 0,
  });
}

const LogoLink = () => {
  return (
    <Link to="/">
      <img src={Logo} alt="Logo Mega Color" />
    </Link>
  );
};

export const Header = (props: {}) => {
  return (
    <>
      <ElevationScroll>
        <AppBar
          sx={{
            bgcolor: "transparent",
            pt: { xs: 1, md: 1 },
            pb: 1,
          }}
        >
          <Toolbar>
            <Box sx={{ flexGrow: 1, pt: 1 }}>
              <Box sx={{ textAlign: { xs: "center", md: "inherit" } }}>
                <LogoLink />
              </Box>
            </Box>
            <BrowserView>
              <Box>
                {isBrowser && (
                  <Button
                    variant="contained"
                    onClick={() => window.open(`mailto:contact@mega-color.com`)}
                  >
                    Contactez-nous
                  </Button>
                )}
              </Box>
            </BrowserView>
          </Toolbar>
        </AppBar>
      </ElevationScroll>
      <Toolbar />
    </>
  );
};
